import { useState } from "react";

import Loading from "@/app/loading";
import { Button, Modal, Table } from "react-bootstrap";

import VariableSearchItemModal from "./variable-search-item-modal";

import api from "@/lib/api";

type VariableSearchTableDataProps = {
  value: number;
  label: string;
  dataset_title: string;
  module_title: string;
  description: string;
}[];

type VariableSearchItemDataProps = {
  dataset: {
    value: number;
    label: string;
  };
  module: {
    value: number;
    label: string;
  };
  item: {
    label: string;
    description: string;
    answer_type_title: string;
    choice_text: string;
  };
};

export default function VariableSearchTable({ data }: { data: VariableSearchTableDataProps | undefined }) {
  const headers = ["LABEL", "DATA SET", "MODULE", "DESCRIPTION"];
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [itemData, setItemData] = useState<VariableSearchItemDataProps | null>(null);

  const handleShowModal = async (id: number) => {
    try {
      setLoading(true);
      const response = await api.get<VariableSearchItemDataProps>(`/hrd/item/${id}`);
      setItemData(response);
    } catch (error) {
      console.error("Error fetching item data:", error);
    } finally {
      setLoading(false);
    }
    setShowModal(true);
  };

  return (
    <>
      <Table bordered responsive className="mt-4">
        <thead>
          <tr className="text-start g2-table-header-blue">
            {headers.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.length != 0 && data != undefined ? (
            data.map(
              (
                item: {
                  value: number;
                  label: string;
                  dataset_title: string;
                  module_title: string;
                  description: string;
                },
                index: number,
              ) => (
                <tr key={item.value} className={index % 2 === 1 ? "table-striped-one" : "table-striped-two"}>
                  <td className="g2-link-blue fw-bold" onClick={() => handleShowModal(item.value)}>
                    {item.label}
                  </td>
                  <td>{item.dataset_title}</td>
                  <td>{item.module_title}</td>
                  <td>{item.description}</td>
                </tr>
              ),
            )
          ) : (
            <tr>
              <td colSpan={headers.length} className="text-center table-striped-one">
                <span className="fst-italic">No results found</span>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" aria-labelledby="country-policy-modal">
        <Modal.Header closeButton>
          <Modal.Title className="g2-text-grey">{itemData?.item.label}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{isLoading ? <Loading /> : <VariableSearchItemModal data={itemData} />}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
